import { computed } from 'mobx';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class PermissionDataService extends DataService<typeof Model.Core.Logic.ViewModels.Security.PermissionItem, Model.Core.Logic.ViewModels.Security.PermissionItem, PermissionItem> {
	protected map(entity: Model.Core.Logic.ViewModels.Security.PermissionItem): PermissionItem {
		return new PermissionItemModel(entity);
	}

	public static make(context?: any): PermissionDataService {
		return new PermissionDataService(context, ctx => ctx.Permissions);
	}

	public add() {
		const entity = new Model.Core.Logic.ViewModels.Security.PermissionItem();
		return entity;
	}
}

export class PermissionItemModel extends EntityModel<Model.Core.Logic.ViewModels.Security.PermissionItem, PermissionItem> implements PermissionItem {
	@property<PermissionItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<PermissionItemModel>(o => o.entity.module, (o, value) => o.entity.module = value)
	public module: string;

	@property<PermissionItemModel>(o => o.entity.name, (o, value) => o.entity.name = value)
	public name: string;

	@property<PermissionItemModel>(o => o.entity.description, (o, value) => o.entity.description = value)
	public description?: string;

	@property<PermissionItemModel>(o => o.entity.parentId, (o, value) => o.entity.parentId = value)
	public parentId?: number;
}



// WEBPACK FOOTER //
// ./src/app/general/roles/form/permission.data.ts